export default __webpack_public_path__ + "static/media/VD1.604e60f1.png";